import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/features/feature-image-3-mockup-hq.webp")